import React, { Component, Fragment } from 'react';
import { Row, Col, Card, Statistic, Icon, Table } from 'antd';
import { inject, observer } from 'mobx-react';
import moment from 'moment-timezone';

@inject('store')
@observer
export class SessionPositionsView extends Component {
    componentDidMount() {
        this.props.store.odysseyBotStore.getTradingSessionPositions(
            this.props.match.params.id,
            this.props.match.params.session_id
        );

        this.props.store.odysseyBotStore.getTradingSession(
            this.props.match.params.id,
            this.props.match.params.session_id
        );
    }
    render() {
        const timezone = this.props.store.userStore.currentUser.timezone;

        return (
            <Fragment>
                {this.renderSessionSummary()}
                <Card title="Closed P&amp;L" bordered={false}>
                    <Table
                        dataSource={this.props.store.odysseyBotStore.tradingSessionPositions}
                        rowKey={'_id'}
                        columns={[
                            {
                                title: 'Side',
                                dataIndex: 'side',
                                key: 'side',
                                render(text) {
                                    return text === 'BUY' ? (
                                        <i className={`fal fa-arrow-up success`} />
                                    ) : text === 'SELL' ? (
                                        <i className={`fal fa-arrow-down error`} />
                                    ) : null;
                                }
                            },
                            {
                                title: 'Qty',
                                dataIndex: 'qty',
                                key: 'qty'
                            },
                            {
                                title: 'Entry Price',
                                dataIndex: 'avg_entry',
                                key: 'avg_entry',
                                render(text, o) {
                                    const b = o.avg_entry;
                                    return b.toFixed(4);
                                }
                            },
                            {
                                title: 'Exit Price',
                                dataIndex: 'avg_exit',
                                key: 'avg_exit',
                                render(text, o) {
                                    const b = o.avg_exit;
                                    return b.toFixed(4);
                                }
                            },
                            {
                                title: 'P&L(Excl fee)',
                                dataIndex: 'pnl',
                                key: 'pnl',
                                render(text) {
                                    return (
                                        <span className={text < 0 ? 'error' : 'success'}>
                                            {text.toFixed(8)}
                                        </span>
                                    );
                                }
                            },
                            {
                                title: 'Fees',
                                dataIndex: 'fees',
                                key: 'fees',
                                render(text) {
                                    return (
                                        <span className={text > 0 ? 'error' : 'success'}>
                                            {text.toFixed(8)}
                                        </span>
                                    );
                                }
                            },
                            {
                                title: 'Created',
                                dataIndex: 'created_at',
                                key: 'created_at',
                                render(text) {
                                    return moment(text)
                                        .tz(timezone)
                                        .format('DD/MM/YYYY hh:mm a');
                                }
                            }
                        ]}
                    />
                </Card>
            </Fragment>
        );
    }

    renderSessionSummary() {
        const session = this.props.store.odysseyBotStore.tradingSession;
        if (!session) return null;

        const x = moment(session.created_at);
        const duration = moment.duration(x.diff(Date.now())).humanize();

        const winRate = (session.won / (session.trades - session.cancelled)) * 100 || 0;
        return (
            <Card
                style={{ marginBottom: 15 }}
                title={`${session.trading_pair} ${session.name} - Win Rate: ${winRate.toFixed(
                    2
                )}% Longs: ${session.long_trades} Shorts: ${session.short_trades}`}
                bordered={false}
            >
                <div style={{ marginBottom: 10 }}>
                    <b>Long Strategy:</b> {session.long_strategy_name}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <b>Short Strategy:</b> {session.short_strategy_name}
                </div>
                <Row gutter={24}>
                    <Col md={3}>
                        <Statistic
                            title="Investment"
                            value={session.account.size}
                            suffix={session.trading_pair.replace('USD', '')}
                        />
                    </Col>
                    <Col md={1}>
                        <Statistic title="Risk" value={session.account.risk} suffix="%" />
                    </Col>
                    <Col md={3}>
                        <Statistic
                            title="PNL"
                            value={session.pnl.toFixed(8)}
                            precision={8}
                            valueStyle={{
                                color: session.pnl >= 0 ? '#29c0b1' : '#FC3367'
                            }}
                            prefix={
                                session.pnl >= 0 ? (
                                    <Icon type="arrow-up" />
                                ) : (
                                    <Icon type="arrow-down" />
                                )
                            }
                            suffix={session.trading_pair.replace('USD', '')}
                        />
                    </Col>

                    <Col md={3}>
                        <Statistic
                            title="Volume"
                            value={session.volume.toFixed(8)}
                            precision={8}
                            suffix={session.trading_pair.replace('USD', '')}
                        />
                    </Col>

                    <Col md={3}>
                        <Statistic
                            title="Fees"
                            value={session.fees.toFixed(8)}
                            precision={8}
                            valueStyle={{
                                color: session.fees <= 0 ? '#29c0b1' : '#FC3367'
                            }}
                            suffix={session.trading_pair.replace('USD', '')}
                        />
                    </Col>

                    <Col md={2}>
                        <Statistic title="Trades" value={session.trades} />
                    </Col>
                    <Col md={2}>
                        <Statistic title="Won" value={session.won} />
                    </Col>
                    <Col md={2}>
                        <Statistic title="Lost" value={session.lost} />
                    </Col>
                    <Col md={2}>
                        <Statistic title="Cancelled" value={session.cancelled} />
                    </Col>
                    <Col md={2}>
                        <Statistic title="Duration" value={duration} />
                    </Col>
                </Row>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/SessionPositionsView/index.js